"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyForRefundConfirmUI = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../shared/core");
var constants_1 = require("../../../constants");
var copy_1 = require("../../../copy");
var ApplyForRefundConfirmUI = function () {
    var _a = (0, core_1.useComponents)(), Card = _a.Card, Heading1 = _a.Heading1, Stack = _a.Stack;
    var _b = (0, core_1.useCopy)(copy_1.defaultOptions), Copy = _b.Copy, copy = _b.copy;
    return (react_1.default.createElement(Card, { "data-testid": "refund-confirmation-success" },
        react_1.default.createElement(Stack, { spaceBetween: [4, 6] },
            react_1.default.createElement("div", null,
                react_1.default.createElement(Heading1, null,
                    react_1.default.createElement(Copy, { copyKey: "confirmHeading" })),
                react_1.default.createElement(Copy, { copyKey: "confirmBody", values: {
                        refundProcessingDays: constants_1.REFUND_PROCESSING_DAYS,
                    } }),
                react_1.default.createElement(Copy, { copyKey: "paymentsBackLink" })),
            react_1.default.createElement(core_1.FeedbackPrompt, { id: "refund", probability: 50, label: copy('refundFeedbackPromptLabel') }))));
};
exports.ApplyForRefundConfirmUI = ApplyForRefundConfirmUI;
